import React, { useEffect, useState } from "react";
import "./Steps.css";
import activeStep1 from "../../assets/active-step-1.svg";
import inactiveStep2 from "../../assets/inactive-step-2.svg";
import inactiveStep3 from "../../assets/inactive-step-3.svg";
import stepCompleted from "../../assets/steps-completed-image.svg";

export default function Steps({ step }) {
  const [stepImages, setStepImages] = useState({
    step1: "",
    step2: "",
    step3: "",
  });

  useEffect(() => {
    const images = {
      step1: step > 1 ? stepCompleted : activeStep1,
      step2: step > 2 ? stepCompleted : step >= 2 ? activeStep1 : inactiveStep2,
      step3: step === 3 ? activeStep1 : inactiveStep3,
    };
    setStepImages(images);
  }, [step]);

  return (
    <div className="steps-wrapper">
      <div className={`step ${step >= 1 ? "active" : ""}`}>
        <img src={stepImages.step1} alt="Step 1" />
        <div className="step-info">
          <h2>Personalization</h2>
        </div>
      </div>
      <div className="progress-bar-wrapper">
        <div className={`step-progress-bar ${step > 1 ? "active" : ""}`}></div>
      </div>
      <div className={`step ${step >= 2 ? "active" : ""}`}>
        <img src={stepImages.step2} alt="Step 2" />
        <div className="step-info">
          <h2>User Details</h2>
        </div>
      </div>
      <div className="progress-bar-wrapper">
        <div className={`step-progress-bar ${step > 2 ? "active" : ""}`}></div>
      </div>
      <div className={`step ${step === 3 ? "active" : ""}`}>
        <img src={stepImages.step3} alt="Step 3" />
        <div className="step-info">
          <h2>Schedule Demo</h2>
        </div>
      </div>
    </div>
  );
}
